<template>
  <div class="create-customer-drawer"
       v-if="drawer">
    <el-drawer :title="title"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <div class="add-item-title"
             style="margin-top: 0">基本信息</div>
        <el-form ref="form"
                 :inline="true"
                 :model="form"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="姓名"
                        prop="shortName">
            <el-input v-model="form.shortName"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="fullName">
            <el-input v-model="form.fullName"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="身份证"
                        prop="contactNumber">
            <el-input v-model="form.contactNumber"
                      maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="附件"
                        prop="address">
            <el-input v-model="form.address"
                      maxlength="50"></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-row>
            <el-form-item label="是否计划">
              <el-checkbox v-model="checked">是</el-checkbox>
            </el-form-item>
            <el-form-item label="计划名称">
              <el-select filterable
                         v-model="form.factoryId"
                         clearable
                         style="width: 100%"
                         placeholder="请选择报名计划"
                         @change="PositionList"
                         ref="entryFactoryId">
                <el-option v-for="item in companyList"
                           :key="item.id"
                           :label="item.customerName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item label="报名企业"
                        prop="form.factoryId">
            <el-select filterable
                       v-model="form.factoryId"
                       clearable
                       style="width: 100%"
                       placeholder="请选择报名企业"
                       @change="PositionList"
                       ref="entryFactoryId">
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.customerName"
                         :value="item.id"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item label="报名职位"
                        prop="factoryId">
            <el-select filterable
                       v-model="form.positionId"
                       ref="entryPositionId"
                       clearable
                       @change="handleChange()"
                       style="width: 100%"
                       placeholder="请先选择企业">
              <el-option v-for="item in positionList"
                         :key="item.id"
                         :label="item.positionName"
                         :value="item.id"></el-option>
            </el-select>

          </el-form-item>
        </el-form>
      </div>
      <div class="rightPadding"></div>

      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit">保 存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>

export default {
  components: {

  },
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
  },
  data () {
    let validatecontactNumber = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (!/^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateHomePage = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (!/[-a-z0-9]+(\.[-a-z0-9]*\.(com|cn|edu|hk))/.test(value)) {
        callback(new Error("网站格式不正确，例子：www.eqlee.com"));
      } else {
        callback();
      }
    };
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      drawer: false,
      companyScale: [],
      checked: false,
      form: {
        license: [],
        logo: [],
        isEnabled: false,
        electronicProtocol: [],
      },
      currentUserInfo: null,
      rules: {
        fullName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        homePage: [{ validator: validateHomePage, trigger: "blur" }],
        shortName: [{ required: true, message: "请输入简称", trigger: "blur" }],
        contactNumber: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { validator: validatecontactNumber, trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请选择行业类别", trigger: "blur" },
        ],
        creditCode: [{ validator: validatecreditCode, trigger: "blur" }],
        isEnabled: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      personForm: {},
      manageInfoForm: {
        contractDate: [],
      },
      CompanyTypeList: [],
      industryList: [],
      invoiceForm: {},
      needInvoice: false,
      companyId: "00000000-0000-0000-0000-000000000000",
      receiver: {
        principal: [],
        own: [],
        other: [],
      },
      customenContacts: [],
      positionList: [],
      companyList: [],
    };
  },
  computed: {

  },
  created () {
    // this.getCompanyScaleData();
    // this.getUserInfo();
  },
  methods: {
    PositionList () {

    },
    getindustryData () {
      this.$api.base.getEnumerationData("industry").then((res) => {
        if (res.error === false || res.Error === false) {
          this.industryList = res.data || res.Data;
        }
      });
    },
    validateForm (formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    onSubmit () {
      if (!this.validateForm("form")) {
        this.$message.warning("填写信息有误，请检查表单");
        return;
      }
      if (this.needInvoice) {
        if (!this.validateForm("invoiceForm")) return;
      }
      this.submitLoading = true;
      let sendData = this.form
      sendData.businessLicense = this.form.license[0]?.url || "";
      sendData.sort = this.form.sort ? this.form.sort : null;
      sendData.logoUrl = this.form.logo[0]?.url || "";
      this.$api.EnterpriseInfo[this.operation == 'edit' ? 'Modify' : 'Create'](sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存成功");
          this.$emit("refreshData");
        } else {

        }
        this.submitLoading = false;
        this.colseDrawer();
        this.companyId = "";
      });
    },
    fillFormData () {

    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },


  },
  watch: {
    drawerShow (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      }
      this.drawer = val;
      if (this.drawer == false) {
        this.companyId = "";
        this.needInvoice = false;
        this.form = {
        };

        return;
      }
      if (this.operation == "edit") {
        this.fillFormData(this.customerInfo);
        // this.setCustomenContacts(this.customerInfo);
      } else {
        // this.setInitReceiver();
      }
    },
  },
};
</script>

<style lang="less">
.create-customer-drawer {
  .el-drawer {
    width: 78% !important;
    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .factory-hide-upload {
    .el-upload--picture-card {
      display: none;
    }

    .el-upload__tip {
      margin-top: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item {
      width: 170px !important;
      height: 146px !important;
    }
  }
  .add-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .tip {
    font-size: 12px;
    color: #909399;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 20px 60px 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 54%;
      }
      .el-select {
        width: 100%;
      }
    }
    .foreign {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #dcdfe6;
    }
    .code-input {
      .el-form-item__content {
        width: calc(54% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
  }
  .rightPadding {
    width: 20%;
    height: 100%;
    float: right;
    // background-color: rgba(0, 0, 0, 0.03);
  }
  .submit-bar {
    position: absolute;
    z-index: 99999;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    background-color: #fff;
    text-align: center !important;
    border-top: 1px solid #ddd;
    padding-right: 20px;
    .el-button {
      padding: 8px 20px;
    }
  }
}
</style>
